/* mofumiya global: reveal-on-scroll, and looping videos that only play while on screen. The <html> gets .mofu-js inline in the head. */
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  const reveal = () => {
    const els = document.querySelectorAll('.mofu-reveal:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach((el) => el.classList.add('is-in')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach((el) => io.observe(el));
  };

  // Autoplay loops cost battery and distract: play them only while visible, and never with reduced motion.
  const videos = () => {
    const els = document.querySelectorAll('video[data-mofu-video]:not([data-mofu-bound])');
    if (!els.length) return;
    els.forEach((v) => {
      v.dataset.mofuBound = '';
      v.muted = true;
      if (reduced.matches) { v.removeAttribute('autoplay'); v.pause(); }
    });
    if (reduced.matches || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        const v = en.target;
        if (en.isIntersecting) { const p = v.play(); if (p && p.catch) p.catch(() => {}); }
        else v.pause();
      });
    }, { threshold: 0.15 });
    els.forEach((v) => io.observe(v));
  };

  // Galleries: one photo at a time, with thumbnails that follow the swipe and jump on click.
  // setTimeout instead of requestAnimationFrame: rAF stops in hidden tabs and the thumbs would freeze.
  const galleries = () => {
    document.querySelectorAll('[data-mofu-thumbs]:not([data-mofu-bound])').forEach((bar) => {
      const g = document.getElementById(bar.dataset.mofuThumbs);
      if (!g) return;
      bar.dataset.mofuBound = '';
      const btns = [...bar.querySelectorAll('button')];
      const items = () => [...g.children];
      const offset = (it) => it.offsetLeft - g.firstElementChild.offsetLeft;
      const show = (best) => {
        btns.forEach((b, i) => b.setAttribute('aria-current', i === best ? 'true' : 'false'));
        const on = btns[best];
        if (on && (on.offsetLeft < bar.scrollLeft || on.offsetLeft + on.offsetWidth > bar.scrollLeft + bar.clientWidth)) {
          bar.scrollTo({ left: on.offsetLeft - (bar.clientWidth - on.offsetWidth) / 2 });
        }
      };
      const mark = () => {
        let best = 0;
        let dist = Infinity;
        items().forEach((it, i) => {
          const d = Math.abs(offset(it) - g.scrollLeft);
          if (d < dist) { dist = d; best = i; }
        });
        show(best);
      };
      btns.forEach((b, i) => b.addEventListener('click', () => {
        const it = items()[i];
        if (it) g.scrollTo({ left: offset(it), behavior: reduced.matches ? 'auto' : 'smooth' });
        show(i);
      }));
      let t;
      g.addEventListener('scroll', () => { clearTimeout(t); t = setTimeout(mark, 60); }, { passive: true });
      mark();
    });
  };

  const init = () => { reveal(); videos(); galleries(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
